import { Button } from 'react-bootstrap';

const AlertWidgetRow = ({
  variant,
  alert,
  colorScale,
  getSeverityLabel,
  canCloseAlert,
  closeAlert,
  getAlerts,
}) => {
  const isCompact = variant === '1x';
  const compactCellPaddingClass = isCompact ? 'px-1 py-1' : 'px-2 py-1';
  const severityColClass = isCompact ? 'col-3' : 'col-2';
  const typeColClass = isCompact ? 'col-4' : 'col-3';
  const senderColClass = 'col-4';
  const textStyle = {
    fontSize: isCompact ? '0.82rem' : '0.85rem',
    lineHeight: isCompact ? 1.15 : 1.2,
    minWidth: 0,
    wordBreak: 'break-word',
  };
  const severityStyle = {
    ...textStyle,
    wordBreak: 'normal',
  };
  const senderStyle = {
    ...textStyle,
    wordBreak: 'normal',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <div className="row g-0 flex-nowrap align-items-start overflow-hidden">
      <div
        className="col-1 align-self-stretch"
        style={{
          backgroundColor: colorScale(alert.severity),
          minHeight: isCompact ? 52 : 48,
          minWidth: variant === '1x' ? 24 : 30,
          maxWidth: variant === '1x' ? 24 : 30,
        }}
      />
      <p className={`${severityColClass} mb-0 ${compactCellPaddingClass}`} style={severityStyle}>
        {getSeverityLabel(alert.severity)}
      </p>
      <p className={`${typeColClass} mb-0 ${compactCellPaddingClass}`} style={textStyle}>
        {alert.type}
      </p>
      <p
        className={`${senderColClass} mb-0 ${compactCellPaddingClass}`}
        style={senderStyle}
        title={alert.sender}
      >
        {alert.sender}
      </p>
      {variant !== '1x' &&
        (canCloseAlert ? (
          <Button
            className="col-2 px-2 py-1 rounded-3 h-auto align-self-center"
            style={{ fontSize: '0.8rem', lineHeight: 1.1 }}
            onClick={(e) => {
              if (
                window.confirm(
                  'Are you sure you want to close this alert? This action cannot be undone.',
                )
              ) {
                closeAlert(e);
                getAlerts();
              }
            }}
            variant="success"
          >
            Close
          </Button>
        ) : (
          <p className={`col-2 mb-0 ${compactCellPaddingClass}`} style={textStyle}>
            Active
          </p>
        ))}
    </div>
  );
};

export default AlertWidgetRow;
